import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CapitalizePipe } from 'app/pipes/capitalize/capitalize.pipe';

@Component({
  selector: 'app-dialog-encontrar-equipamentos',
  standalone: true,
  imports: [CommonModule, CapitalizePipe],
  templateUrl: './dialog-encontrar-equipamentos.html',
  styleUrls: ['./dialog-encontrar-equipamentos.css']
})
export class DialogEncontrarEquipamentosComponent {
  @Input({ required: true }) equipamento: any = null;
  @Input({ required: true }) mostrar: boolean = false;
  @Output() fechar = new EventEmitter<void>();

  public fecharDialog(): void {
    this.fechar.emit();
  }
}